<template>
    <div>
            <article
                class="message pb-6"
            >
                
                <div
                    id="session_active"
                    class="message-body"
                >
                    <div class="message-body-content px-4 py-4" v-if="activeSession._id">
                        <div class="pb-4">
                            
                            <label
                                v-t="'game_session_title'"
                                class="label has-text-black pb-0" 
                            ></label><p class="is-size-4 has-text-weight-bold has-text-primary">{{activeSession.title}}</p>
                            <!--<div class="control">
                                <input :disabled="isRunningSession || isMemory || isQuizHunt" v-model="activeSession.title" ref="titleSession" class="input secondary-font" type="text" :placeholder="$t('game_session_title_hint')">
                            </div>-->
                        </div>
                        <div
                            class="
                                columns
                                is-mobile is-centered
                                py-0
                                is-vcentered
                            "
                        >
                            <div class="column is-6 is-paddingless">
                                <figure class="image is-square remove-margin">
                                    <vue-qrcode
                                        ref="qrcode"
                                        :value="
                                            qrUrl
                                        "
                                    />
                                </figure>
                            </div>
                            <div class="column is-6 is-paddingless">
                                <p class="is-size-6 has-text-black">
                                    {{ $t('Sessions.code') }}
                                </p>
                                <p
                                    class="
                                        is-size-4
                                        has-text-weight-bold has-text-primary
                                        mb-2
                                    "
                                >
                                    {{ activeSession.shortCode }}
                                </p>

                                <p class="is-size-6 has-text-black">
                                    {{ $t('Sessions.participants_count') }}
                                </p>
                                <p
                                    class="
                                        is-size-4
                                        has-text-primary has-text-weight-bold
                                    "
                                >
                                    {{
                                        activeSession.participants
                                            ? activeSession.participants.length
                                            : 0
                                    }}
                                </p>
                            </div>
                        </div>

                        <div v-if="isWeb">
                            <label v-t="'game_session_link'" class="label pt-4 has-text-black"></label>
                            <div class="field has-addons shareUrl">
                                <p class="control is-expanded mb-0">
                                    <input :value="shareSessionURL" readonly class="input is-6" type="text" />
                                </p>
                                <p class="control">
                                    <a
                                        :class="{
                                            'has-tooltip-active': showCopiedTooltipLink,
                                        }"
                                        :data-tooltip="
                                            $t(
                                                showCopiedTooltipLink
                                                    ? 'Sessions.url_copied'
                                                    : 'Sessions.copy_url'
                                            )
                                        "
                                        class="button is-disabled has-tooltip-left"
                                        @click="copyURL"
                                    >
                                        <span class="icon is-small">
                                            <i class="mdi mdi-18px mdi-content-copy"></i>
                                        </span>
                                    </a>
                                </p>
                                <a :href="shareSessionURL" target="_blank" >
                                        <button
                                            class="button is-primary is-size-6 is-radiusless ml-4"
                                            style="height: 100%"
                                            v-t="'go_to_play'"
                                        />
                                    </a>
                            </div>
                        </div>

                        <div class="pb-2" v-if="canShowGameStats">
                            <label v-t="'game_session_stats'" class="label pt-4 has-text-black"></label>
                            <router-link style="width:50%"
                            :to="{
                                name: 'session-detail',
                                params: { _id: activeSession._id },
                            }"
                            target="_blank"
                            ><button
                                class="
                                    button
                                    is-eduloc-orange is-size-6 is-radiusless
                                "
                                style="height: 100%; width:50%"
                                v-t="'Sessions.stats'"
                            /></router-link>
                        </div>

                        <hr />

                        
                        <div class="pt-2"  >
                            <button
                                class="
                                    button
                                    is-eduloc-red is-size-6 is-radiusless is-fullwidth
                                "
                                :disabled="isRunningSession"
                                style="height: 100%;  margin:0 auto;"
                                v-t="'memory_game_configuration'"
                                @click="openGameConfiguration"
                            />
                        </div>

                        <!--<div v-if="isRunningSession" class="mb-4 pt-4">
                            <div class="notification is-eduloc-green running-session-message" v-html="$t('game_session_no_session_edition')"/>
                        </div>-->

                    </div>
                    <div v-else class="message-body-content px-4 py-4">
                        <div class="notification is-warning" v-html="$t('game_session_no_active_session')"/>
                    </div>
                </div>
            </article>

            <div class="action-buttons-container mb-2">
                <a @click="discardUnsavedChanges" class="button is-primary">
                    <span class="icon is-small my-2"
                        ><i
                            class="mdi mdi-32px mdi-chevron-double-left"
                            aria-hidden="true"
                        ></i
                    ></span>
                </a>
                
                <!--<a
                    @click="validateAndSave"
                    class="button is-primary primary-font is-size-5"
                >
                    {{ $t('Buttons.save') }}
                </a>-->
            
            </div>


    </div>
</template>

<script>
import { fetchItems, updateItem } from '@/services/API';
import _ from 'underscore';
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import moment from 'moment';
import VueQrcode from 'vue-qrcode';
import LProjectSessionsList from '@/components/LProjectSessionsList';
import {POINTS_DEFAULT} from '@/lib/constants';
export default {
    components: {
        VueQrcode,
        LProjectSessionsList
    },
    props: {
        activeSession: { type: Object, default: {} },
    },
    data() {
        return { 
            sessions: [], 
            session: {},
            showCopiedTooltipLink: false,
            originalSession:{},
            pointsValues: POINTS_DEFAULT,
            baseURL: process.env.VUE_APP_WWW_URL,
        };
        
    },
    filters: {
        createdDate(timestamp) {
            return moment(timestamp).format('DD/MM/YYYY');
        },
    },
    computed: {
        isMemory() {
            return this.$store.getters.project.type == 'memory' || this.$store.getters.project.format == 'PROJECT_TYPE_MEMORY';
        },
        isQuizHunt() {
            return this.$store.getters.project.type == 'quizhunt' || this.$store.getters.project.format == 'PROJECT_TYPE_QUIZHUNT';
        },
        closerClasses(){
            let classes;
            if(this.activeSession.configuration.closer==true){
                classes += " is-primary"
            }
            if(this.isRunningSession){
                classes += ' disabled'
            }
            return classes;
        },
        chosingClasses(){
            let classes;
            if(this.activeSession.configuration.closer==false){
                classes += " is-primary"
            }
            if(this.isRunningSession){
                classes += ' disabled'
            }
            return classes;
        },
        project() {
            return this.$store.getters.project;
        },
        editing() {
            // console.log(this.session, this.session._id);
            return this.session._id ? true : false;
        },

        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        hasActiveSession(){
            return this.activeSession.length;
        },
        isModeMap() {
            return this.$store.getters.project.mode == 'map';
        },
        isWeb() {
            // console.log('isWeb', this.session.configuration.web === true);
            return (
                this.activeSession.configuration.web &&
                !this.activeSession.configuration.app
            );
        },
        isApp() {
            // console.log('isApp', this.session.configuration.app === true);
            return (
                this.activeSession.configuration.app &&
                !this.activeSession.configuration.web
            );
        },
        isTrivial() {
            return this.$store.getters.project.type == 'trivial';
        },
        isRunningSession(){
            return this.activeSession.isActive&&!this.activeSession.isPaused;
        },
        shareSessionURL() {
            return (
                process.env.VUE_APP_SHARE_SESSION_URL +
                this.activeSession.shortCode +
                '&lang=' +
                this.$i18n.locale
            );
        },
        canShowGameStats() {
            if (this.$store.getters.activePlan) {
                return this.$store.getters.activePlan.configuration.project.gameStats
            }
            return false;
        },
        qrUrl() {
            // console.log(this.baseURL+'/gotoapp?code='+this.entityCode)
            return encodeURI(this.baseURL + '/goapp.html?code=' + this.activeSession.shortCode);
        }
    },
    async mounted() {
        this.$nextTick(() => {
            // console.log(this.activeSession._id)
            this.originalSession = JSON.parse(JSON.stringify(this.activeSession));
            // console.log("is quizHunt?",this.isQuizHunt)
        });
    },
    methods: {
        isActive(option) {
            if (this.$refs[option]) {
                if (this.$refs[option].classList.contains('is-active')) {
                    this.$refs[`${option}-icon`].childNodes[0].classList.remove(
                        'fa-caret-up'
                    );
                    this.$refs[`${option}-icon`].childNodes[0].classList.add(
                        'fa-caret-down'
                    );
                } else {
                    this.$refs[`${option}-icon`].childNodes[0].classList.remove(
                        'fa-caret-down'
                    );
                    this.$refs[`${option}-icon`].childNodes[0].classList.add(
                        'fa-caret-up'
                    );
                }
            }
        },
        playType(session) {
            if (!session.configuration.app && !session.configuration.web) {
                return 'ALL';
            } else if (session.configuration.web) {
                return 'WEB';
            } else if (session.configuration.app) {
                return 'APP';
            }

            return 'ALL';
        },
        setCloserOn() {
            if(this.isRunningSession){
                return;
            }
            this.activeSession.configuration.closer = true;
        },
        setCloserOff() {
            if(this.isRunningSession){
                return;
            }
            this.activeSession.configuration.closer = false;
        },
        setResetOn() {
            if(this.isRunningSession){
                return;
            }
            this.activeSession.allowsReset = true;
        },
        setResetOff() {
            if(this.isRunningSession){
                return;
            }
            this.activeSession.allowsReset = false;
        },
        setWeb() {
            if(this.isRunningSession){
                return;
            }
            this.activeSession.configuration.app = false;
            this.activeSession.configuration.web = true;
        },
        setApp() {
            if(this.isRunningSession){
                return;
            }
            this.activeSession.configuration.app = true;
            this.activeSession.configuration.web = false;
        },
        copyURL() {
            this.$copyText(this.shareSessionURL).then((e) => {
                this.showCopiedTooltipLink = true;
                setTimeout(() => {
                    this.showCopiedTooltipLink = false;
                }, 1500);
            });
        },
        discardUnsavedChanges(){
            // this.activeSession=this.originalSession;
            this.$emit('close');
        },
        validateAndSave(){
            console.log("saving")
        },
        openGameConfiguration() {
            if (this.isRunningSession) {
                return;
            }
            this.$emit("editGameSession")
            // console.log("open editing conf")
        },
        
    },
};
</script>

<style scoped>
@import '../assets/css/leftPanel.css';
.message {
    background-color: transparent;
    border-radius: 0;
    font-size: 1rem;
    margin-bottom: 0;
    overflow-y: auto;
    max-height: calc(100vh - 45px);
    overflow-x: hidden;
    font-family: var(--primary-font);
    max-height: calc(100vh - 150px);
}
.running-session-message{
    font-family: var(--primary-font);
    border-radius: 0px;
}

.message
    a:not(.button):not(.lb-button):not(.lb-toolbar-button_images):not(.lb-toolbar-button_video):not(.lb-toolbar-button_files):not(.lb-toolbar-button_audio):not(.lb-toolbar-button_url):not(.lb-toolbar-button_location):not(.lb-toolbar-button_tags):not(.lb-toolbar-button_question):not(.lb-toolbar-button_object):not(.lb-toolbar-button_point):not(.lb-delete-media):not(.lb-answer):not(.lb-multiple-answer):not(.tag):not(.lb-bain-tag-functional):not(.lb-bain-tag-emotional):not(.lb-bain-tag-life-changer):not(.lb-bain-tag-social-impact):not(.lb-role-tag_administrator):not(.lb-role-tag_teacher):not(.lb-role-tag_student):not(.lb-role-tag_coordinator):not(.lb-role-tag_participant):not(.lb-role-tag_facilitator):not(.lb-status-tag_active):not(.lb-status-tag_inactive):not(.lb-status-tag_invited):not(.dropdown-item) {
    text-decoration: none;
}
.message-body {
    overflow-x: hidden;
    border-left-style: hidden;
}
.message-body button{
    font-family: var(--primary-font);
}
.message-body label.is-italic{
    font-family: var(--secondary-font);
}

.button.is-multiline {
  min-height: 2.25em;
  white-space: unset;
  height: auto;
  flex-direction: column;
}

.bottom-full-button{
    position: absolute;
    bottom: 0;
    border-radius: 0px;
    width: 100%;
}
 .input[disabled],.textarea[disabled]{
    background-color: white;
    border-color: whitesmoke;
    box-shadow: none;
    color: #9b9b9b;
}
.button[disabled]{
    border: none;
}
.remove-margin{
    margin-left: -15px;
    margin-right: 15px;
}
</style>
